import { combineReducers } from '@reduxjs/toolkit';

import { usersListReducer } from './usersListSlice';

export const usersReducer = combineReducers({
  list: usersListReducer,
});
